import React from 'react';
import BsForm from 'react-bootstrap/es/Form';
/**
 * This is the Form component, use this if you want to create any form of some kind, or a single element like Input.
 * <br />
 * It is a direct proxy of [React Bootstrap's Form](https://react-bootstrap.github.io/components/forms/).
 */

var Form = function Form(props) {
  return React.createElement(BsForm, props);
};

Form.displayName = 'Form';
Form.Text = BsForm.Text;
Form.Row = BsForm.Row;
Form.Group = BsForm.Group;
Form.Label = BsForm.Label;
Form.Control = BsForm.Control;
Form.Control.Feedback = BsForm.Control.Feedback;
Form.Check = BsForm.Check;
Form.Check.Input = BsForm.Check.Input;
Form.Check.Label = BsForm.Check.Label;
export default Form;